import { useSelector } from "react-redux";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";

// assets
import accountIcon from "assets/avatars/accountIcon.svg";

function Navbar({ showSidebar, onSidebarChange }) {
  const { authorization } = useSelector((state) => state?.auth);

  const MenuOutlinedStyle = {
    fontSize: "35px",
    color: "#356ab3",
    marginBlockEnd: "10px",
    marginInlineStart: "20px",
  };

  return (
    <nav className="navbar d-flex justify-content-between align-items-center">
      {showSidebar ? (
        <MenuFoldOutlined
          style={MenuOutlinedStyle}
          onClick={() => onSidebarChange(false)}
          role="button"
        />
      ) : (
        <MenuUnfoldOutlined
          style={MenuOutlinedStyle}
          onClick={() => onSidebarChange(true)}
          role="button"
        />
      )}
      <div className="navbar__right d-flex align-items-center gap-2">
        {authorization?.salesId && (
          <span className="navbar__sales-id">
            Sales ID: {authorization.salesId}
          </span>
        )}
        <img className="navbar__account-icon" src={accountIcon} alt="" />
      </div>
    </nav>
  );
}

export default Navbar;
